import React, { useRef } from 'react';
import styled from 'styled-components';
import { Carousel } from 'antd';

import { NextArrowIcon } from '@src/components/common/icons/NextArrowIcon';
import { PrevArrowIcon } from '@src/components/common/icons/PrevArrowIcon';

const Content = styled.div`
	background: #FFFFFF;
	max-width: 100vw;
	width: 100%;
	overflow: hidden;
	word-break: break-all;
	cursor: pointer;
	:hover {
		.title {
			color: ${props => props.theme.colors.primary};
		}
	}
`;

const ImageWrap = styled.div`
	position: relative;
`;

const StyledCarousel = styled(Carousel)`
	& .slick-dots .slick-active {
		width: 6px !important;
		height: 6px !important;
	};
	& .slick-dots .slick-active button {
		border-radius: 100px !important;
		width: 6px !important;
		 height: 6px !important;
	};
	& .slick-dots {
		width: 6px !important;
		height: 6px !important;
		margin: unset !important;
    left: 50% !important;
	};
	& .slick-dots button {
		border-radius: 100px !important;
		width: 6px !important;
		 height: 6px !important;
	};

	@media 
	${props => props.theme.device.mobile},
	${props => props.theme.device.smTablet}
	{
		width: 162px;
	}
`;

const InfoContent = styled.div`
	padding: 8px;
`;

const Title = styled.div`
	font-weight: 500;
	font-size: 18px;
	color: #363636;
	margin-bottom: 8px;
`;

const Desc = styled.div`
	font-size: 12px;
	color: #797979;
`;

const NextBtn = styled.div`
	position: absolute;
	top: calc(50% - 12px);
	right: 0px;
	z-index: 1;
`;

const PrevBtn = styled.div`
	position: absolute;
	top: calc(50% - 12px);
	left: 0px;
	z-index: 1;
`;

interface ILearningPathCard {
	photos: {
		id: string;
		link: string;
		alt?: string;
	}[],
	title: string;
	desc: string;
	onClick: () => void;
}

// eslint-disable-next-line arrow-body-style
const LearningPathCard = ({ photos, title, desc, onClick }: ILearningPathCard): JSX.Element => {
	const slider = useRef(null);
	const nextButton = e => {
		e.stopPropagation();
		slider.current.next();
	};
	const prevButton = e => {
		e.stopPropagation();
		slider.current.prev();
	};
	return (
		<Content onClick={onClick}>
			<ImageWrap>
				{
					photos.length > 1 && (
						<PrevBtn onClick={prevButton}>
							<PrevArrowIcon />
						</PrevBtn>
					)
				}
				<StyledCarousel swipeToSlide draggable ref={slider}>
					{
						photos.map(photo => (
							<img key={photo.id} src={photo.link} alt={photo.alt} />
						))
					}
				</StyledCarousel>
				{
					photos.length > 1 && (
						<NextBtn onClick={nextButton}>
							<NextArrowIcon />
						</NextBtn>
					)
				}
			</ImageWrap>
			<InfoContent>
				<Title className="title">{title}</Title>
				<Desc>{desc}</Desc>
			</InfoContent>
		</Content>
	);
};

export default LearningPathCard;
